import { render, staticRenderFns } from "./subject-form.vue?vue&type=template&id=4731f0cf&scoped=true&"
import script from "./subject-form.vue?vue&type=script&lang=ts&"
export * from "./subject-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731f0cf",
  null
  
)

export default component.exports